const FETCH_SUCCESS = "FETCH_SUCCESS"
const FETCH_FAILED = "FETCH_FAILED"
const RESET = "RESET"

export {
  FETCH_SUCCESS,
  FETCH_FAILED,
  RESET
}